const dlsIconNameMap = {
  'acupuncture-lg': 'dls-icon-acupuncture',
  'acupuncture': 'dls-icon-acupuncture',
  'ambulatory': 'dls-icon-doctor-large', // not previously in ch-icon
  'autism-lg': 'dls-icon-autism',
  'autism': 'dls-icon-autism',
  'ch-logo-horizontal-oe': 'dls-logo-ch-horizontal-oe',
  'ch-logo-horizontal': 'dls-logo-ch-horizontal',
  'ch-logo-vertical': 'dls-logo-ch-vertical',
  'ch-mark': 'dls-logo-ch-mark',
  'chiropractic-lg': 'dls-icon-chiropractic',
  'chiropractic': 'dls-icon-maternity', // name mismatch due to usage as ovia partner icon
  'concern': 'dls-icon-mental-health',
  'contacts-lg': 'dls-icon-contacts',
  'contacts': 'dls-icon-contacts',
  'dental-lg': 'dls-icon-dental',
  'dental': 'dls-icon-dental',
  'dentalbasic-lg': 'dls-icon-dental-basics',
  'dentalbasic': 'dls-icon-dental-basics',
  'dentalmajor-lg': 'dls-icon-dental-major',
  'dentalmajor': 'dls-icon-dental-major',
  'dentalortho-lg': 'dls-icon-orthodontics',
  'dentalortho': 'dls-icon-orthodontics',
  'dentaloverview': 'dls-icon-dental', // not previously in ch-icon
  'diabetes-lg': 'dls-icon-diabetes',
  'diabetes': 'dls-icon-diabetes',
  'diabeticeyecare-lg': 'dls-icon-diabetic-eye-care',
  'diabeticeyecare': 'dls-icon-diabetic-eye-care',
  'doctorondemand': 'dls-icon-doctor-visit',
  'doctorvisit-lg': 'dls-icon-doctor-visit',
  'doctorvisit': 'dls-icon-fertility', // name mismatch due to usage as progyny partner icon
  'emergency-lg': 'dls-icon-emergency',
  'emergency': 'dls-icon-emergency',
  'equipment-lg': 'dls-icon-equipment',
  'equipment': 'dls-icon-equipment',
  'fertility-lg': 'dls-icon-fertility',
  'fertility': 'dls-icon-fertility',
  'glasses-lg': 'dls-icon-frames',
  'glasses': 'dls-icon-frames',
  'grandrounds': 'dls-icon-doctor-visit',
  'heal': 'dls-icon-home-health',
  'healthcarebluebook': 'dls-icon-health-funds',
  'hospital-lg': 'dls-icon-medical-facility',
  'hospital': 'dls-icon-occupational-therapy', // name mismatch due to usage as robin care partner icon
  'imaging-lg': 'dls-icon-imaging',
  'imaging': 'dls-icon-imaging',
  'jiff': 'dls-icon-nutrition',
  'kurbohealth': 'dls-icon-physical-therapy', // not previously in ch-icon
  'labs-lg': 'dls-icon-labs',
  'labs': 'dls-icon-labs',
  'lasik-lg': 'dls-icon-lasik',
  'lasik': 'dls-icon-hospice', // name mismatch due to usage as sleep.io partner icon
  'livongo': 'dls-icon-diabetes',
  'magellan': 'dls-icon-mental-health',
  'maternity2': 'dls-icon-maternity',
  'maternity3': 'dls-icon-maternity',
  'maternity-lg': 'dls-icon-maternity',
  'maternity': 'dls-icon-maternity',
  'medicallocation': 'medical-location', // existing ch-icon w/dls-icon-loader, TODO: replace with illustration
  'mental-lg': 'dls-icon-mental-health',
  'mental': 'dls-icon-mental-health',
  'metlifeeap': 'dls-icon-mental-health',
  'milkstork': 'dls-icon-maternity', // not previously in ch-icon
  'mra': 'dls-icon-partner', // not previously in ch-icon
  'mybrainsolutions': 'dls-icon-mental-health', // not previously in ch-icon
  'nimblerx': 'dls-icon-pharmacy',
  'nurseline': 'dls-icon-urgent-care', // was dls-icon-phone in a previous mapping
  'nutrition-lg': 'dls-icon-nutrition',
  'nutrition': 'dls-icon-nutrition',
  'onemedical': 'dls-icon-doctor-large',
  'onsiteclinic': 'dls-icon-doctor-visit',
  'ot-lg': 'dls-icon-occupational-therapy',
  'ot': 'dls-icon-occupational-therapy',
  'ovuline': 'dls-icon-maternity',
  'pharmacy-lg': 'dls-icon-pharmacy',
  'pharmacy': 'dls-icon-pharmacy',
  'physicaltherapy-lg': 'dls-icon-physical-therapy',
  'physicaltherapy': 'dls-icon-physical-therapy',
  'play-arrow': 'dls-icon-circle-play',
  'preventive-lg': 'dls-icon-clipboard-basic-large', // exists in dls-icons ^2.14.x
  'preventive': 'dls-icon-clipboard-basic', // exists in dls-icons ^2.14.x
  'progyny': 'dls-icon-fertility', // not previously in ch-icon
  'quitnet': 'dls-icon-no-smoking',
  'radio': 'radio-normal', // existing ch-icon w/dls-icon-loader, TODO: replace w/component eventually
  'radio-selected': 'radio-selected', // existing ch-icon w/dls-icon-loader, TODO: replace w/component eventually
  'rethink': 'dls-icon-autism',
  'speechtherapy-lg': 'dls-icon-speech-therapy',
  'speechtherapy': 'dls-icon-doctor-large', // name mismatch due to usage as caresupport partner icon
  'status': 'dls-icon-partner', // not previously in ch-icon
  'syringe-lg': 'dls-icon-syringe-large', // exist in dls-icons ^2.14.x
  'syringe': 'dls-icon-syringe', // exist in dls-icons ^2.14.x
  'surgery-lg': 'dls-icon-surgery',
  'surgery': 'dls-icon-occupational-therapy', // name mismatch due to usage as wellthy partner icon
  'telemedicine-lg': 'dls-icon-telemedicine',
  'telemedicine': 'dls-icon-telemedicine',
  'tobaccocessation-lg': 'dls-icon-no-smoking',
  'tobaccocessation': 'dls-icon-no-smoking',
  'transgender-lg': 'dls-icon-transgender',
  'transgender': 'dls-icon-transgender',
  'urgentcare-lg': 'dls-icon-urgent-care',
  'urgentcare': 'dls-icon-urgent-care',
  'visionexam-lg': 'dls-icon-vision-exam',
  'visionexam': 'dls-icon-vision-exam'
};

export default dlsIconNameMap;



// WEBPACK FOOTER //
// ./services/dlsIconNameMap.js